import getPlayfieldPosition from './playfieldPosition';
import './EnemyShip.css';

function EnemyShip({ enemy }) {
  return (
    <div
      className={`enemy enemy-${enemy.type ?? 'scout'} enemy-lean-${enemy.lean ?? 'center'}`}
      style={getPlayfieldPosition(enemy.x, enemy.y)}
      aria-hidden="true"
    >
      <img src={`${process.env.PUBLIC_URL}/enemy-ship.png`} alt="" />
    </div>
  );
}

export default EnemyShip;
